module.exports = __webpack_public_path__ + "static/media/pocketcasts.ade6767d.svg";